/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Action_Audit_BlockInputs */



/**
* | output |
* | --- |
* | "Audit + Block" |
*
* @param {Compliance_Action_Audit_BlockInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_action_audit_block = /** @type {((inputs?: Compliance_Action_Audit_BlockInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Action_Audit_BlockInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Audit + Blockieren")
	return /** @type {LocalizedString} */ ("Audit + Block")
});